import styled from 'styled-components';
import { media } from '../../../style/media';
import { white, contiOrange } from '../../../style/colors';

export const PricelistsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 24px;

  ${media.m`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.s`
    grid-template-columns: 1fr;
  `}
`;

export const PricelistCard = styled.div`
  background: ${white};
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 2px solid #e5e7eb;
  background: #f9fafb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const CardHeaderLeft = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CardTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 2px 0;
  color: ${contiOrange};
`;

export const CardSubtitle = styled.p`
  font-size: 13px;
  margin: 0;
  color: #6b7280;
`;

export const AddTyreIconButton = styled.button`
  background: ${contiOrange};
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  color: ${white};
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;

  &:hover {
    background: #ff8c00;
    box-shadow: 0 2px 8px rgba(255, 165, 0, 0.3);
  }

  i {
    font-size: 16px;
  }
`;

export const CardBody = styled.div`
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 36px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #111827;
  background: ${white};
  cursor: text;
  transition: all 0.2s;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cpath d='m21 21-4.35-4.35'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 10px center;

  &:focus {
    outline: none;
    border-color: ${contiOrange};
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

